import { Box, Card, CardContent, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import SimulationCode from '../simulation-code/SimulationCode';
import SimulatorAvatar from '../simulator-avatar/SimulatorAvatar';
import { ExerciseType, SimulatorType } from '../types';

export interface ClassroomCardProps {
  adHoc: boolean;
  actions?: ReactNode;
  code: string;
  exerciseName: string;
  exerciseType: ExerciseType;
  simulatorType: SimulatorType;
}

const ClassroomCard = ({ adHoc, actions, code, exerciseName, exerciseType, simulatorType }: ClassroomCardProps) => {
  return (
    <Card sx={{ backgroundColor: theme => theme.palette.background.default, mt: 4, mb: 3 }}>
      <CardContent sx={{ display: 'flex', gap: 3 }}>
        <SimulatorAvatar
          adHoc={adHoc}
          exerciseType={exerciseType}
          simulatorType={simulatorType}
          sx={{ display: { xs: 'none', md: 'grid' }, height: 160, width: 160 }}
        />

        <Box flex="1" display="flex" flexDirection="column" position="relative">
          <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={2} sx={{ mb: 3 }}>
            <Typography variant="overline">Simulation</Typography>
            <Box display="flex" gap={2}>
              {actions}
            </Box>
          </Box>

          <Box display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={2}>
            <Box>
              <Typography component="h1" variant="h4" mb={1}>
                Set up team
              </Typography>
              <Typography color="primary">{exerciseName}</Typography>
            </Box>

            <SimulationCode code={code} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ClassroomCard;
